import React from 'react';
import { StarIcon } from 'lucide-react';
import { motion } from 'framer-motion';
const testimonials = [{
  quote: 'Pensé que era yo… pero era falta de sistema.',
  name: 'Martín G.',
  initial: 'M'
}, {
  quote: 'Pasé de no controlar nada… a decidir cuándo terminar.',
  name: 'Alejandro R.',
  initial: 'A'
}, {
  quote: 'Esto debería enseñarse antes.',
  name: 'Carlos M.',
  initial: 'C'
}];
export function Testimonials() {
  return <motion.section initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-50px'
  }} transition={{
    duration: 0.5
  }} className="py-20 px-4 max-w-6xl mx-auto" data-id="element-324">
      <div className="text-center mb-12" data-id="element-325">
        <h2 className="text-3xl font-heading text-white uppercase mb-2" data-id="element-326">
          👇 LO QUE DICEN OTROS HOMBRES:
        </h2>
        <p className="text-gray-400 italic text-lg" data-id="element-327">
          Resultados reales de hombres como vos
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-328">
        {testimonials.map((t, i) => <div key={i} className="bg-gray-900 border border-gray-800 p-8 rounded-2xl flex flex-col items-center text-center shadow-lg relative pt-12" data-id="element-329">
            <span className="absolute top-4 left-6 text-6xl text-gray-800 font-serif leading-none" data-id="element-330">
              "
            </span>
            <div className="flex mb-6 relative z-10" data-id="element-331">
              {[...Array(5)].map((_, idx) => <StarIcon key={idx} className="w-6 h-6 text-brand-gold fill-current" data-id="element-332" />)}
            </div>
            <p className="text-gray-300 italic mb-8 flex-grow text-lg relative z-10" data-id="element-333">
              "{t.quote}"
            </p>
            <div className="flex flex-col items-center" data-id="element-334">
              <div className="flex items-center mb-2" data-id="element-335">
                <div className="w-12 h-12 bg-gray-800 rounded-full flex items-center justify-center text-white font-bold text-xl mr-4 shadow-inner" data-id="element-336">
                  {t.initial}
                </div>
                <span className="text-white font-bold text-lg" data-id="element-337">{t.name}</span>
              </div>
              <span className="text-xs text-brand-green font-bold flex items-center mt-1" data-id="element-338">
                ✅ Compra Verificada
              </span>
            </div>
          </div>)}
      </div>
    </motion.section>;
}